import { useEffect, useRef, useState } from "react";

type LoaderProps = {
  isScreen?: boolean;
  processing?: boolean;
  timeoutDuration?: number;
  permanant?: boolean;
};

function JLoader({
  isScreen = false,
  processing = true,
  timeoutDuration = 400,
  permanant = false,
}: LoaderProps) {
  const [state, setState] = useState("idle");
  const timeout: { current: ReturnType<typeof setTimeout> | null } =
    useRef(null);

  useEffect(() => {
    if (processing && state === "idle") {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      timeout.current = setTimeout(() => {
        setState("display");
      }, timeoutDuration);
      setState("delay");
    }

    if (processing === false && timeout.current) {
      clearTimeout(timeout.current);
      setState("idle");
    }

    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [state, timeoutDuration, processing]);

  if (state === "display" || permanant) {
    return (
      <div className="data-loader-box">
        {isScreen ? (
          <div className="data-loader">
            <i className="fas fa-spinner fa-2x rotate" />
            <p className="text">Chargement...</p>
          </div>
        ) : (
          <div>Chargement...</div>
        )}
      </div>
    );
  }

  return null;
}

export default JLoader;
